export const fullOptions = {
    autosave_ask_before_unload: true,
    autosave_interval: '30s',
    autosave_prefix: '{path}{query}-{id}-',
    autosave_restore_when_empty: false,
    autosave_retention: '2m',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }',
    contextmenu: 'link image table',
    editimage_cors_hosts: ['picsum.photos'],
    file_picker_callback: (callback, value, meta) => {
        if (meta.filetype === 'file') {
            callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
        }
        if (meta.filetype === 'image') {
            callback('https://www.google.com/logos/google.jpg', {
                alt: 'My alt text',
            });
        }
        if (meta.filetype === 'media') {
            callback('movie.mp4', {
                poster: 'https://www.google.com/logos/google.jpg',
                source2: 'alt.ogg',
            });
        }
    },
    height: 600,
    image_advtab: true,
    image_caption: true,
    image_class_list: [
        { title: 'None', value: '' },
        { title: 'Some class', value: 'class-name' },
    ],
    image_list: [
        {
            title: 'hivebrite',
            value: 'https://hivebrite.io/wp-content/uploads/2023/07/Hivebrite-logo-2023.svg',
        },
        { title: 'lumenalta', value: 'https://lumenalta.com/lumenalta.svg' },
    ],
    importcss_append: true,
    link_list: [
        { title: 'hivebrite', value: 'https://hivebrite.io/' },
        { title: 'lumenalta', value: 'https://lumenalta.com/' },
    ],
    menubar: 'file edit view insert format tools table help',
    noneditable_class: 'mceNonEditable',
    plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
    template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
    templates: [
        {
            content: '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
            description: 'creates a new table',
            title: 'New Table',
        },
        {
            content: 'Once upon a time...',
            description: 'A cure for writers block',
            title: 'Starting my story',
        },
        {
            content: '<div class="mceTmpl"><span class="cdate">cdate</span><br><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
            description: 'New List with dates',
            title: 'New list with dates',
        },
    ],
    toolbar: 'undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link image | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | save print | pagebreak anchor codesample | ltr rtl',
    toolbar_mode: 'sliding',
};
//# sourceMappingURL=full.js.map